import script from "./FormLayoutBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLayoutBlock.vue?vue&type=script&setup=true&lang=js"

import "./FormLayoutBlock.vue?vue&type=style&index=0&id=2d7e12fe&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7e12fe"]])

export default __exports__